import React from "react";
import { HashLink } from "react-router-hash-link";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  stretch: { display: "flex", alignItems: "stretch" },
  item: {
    cursor: "pointer",
    border: "1px solid #dee5ec",
    borderRadius: "20px",
    textAlign: "center",
    "&:hover": {
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    },
  },
  product__content: {
    marginBottom: "70px",
  },
  product__img: {
    maxWidth: "500px",
    minWidth: "200px",
    borderRadius: "2%",
    cursor: "pointer",
  },
  productMenu: { lineHeight: "2.3em" },
  font13: { fontSize: "11px", color: "#757575" },
});

const CleansingMenu = () => {
  const { t, i18n } = useTranslation();
  document.title = "Heslet Cleaning Product";
  const classes = useStyles();
  return (
    <Grid item md={3} px={5} py={4} className={classes.productMenu}>
      <Box className="menu_bredcrumb">
        <HashLink smooth to="/">
          {t("bread_home")}{" "}
        </HashLink>
        /{" "}
        <HashLink smooth to="/products-cleansing">
          {t("bread_cleansing")}
        </HashLink>
      </Box>
      <Box className="small_menu_title" sx={{ mb: 3 }}>
        {t("Cleansing")}
        <Box
          sx={{
            width: 1 / 4,
            borderBottom: "1px solid lightgray",
            pt: 1,
          }}
        ></Box>
      </Box>
      <Box className="menu_small_title" sx={{ pl: 2 }}>
        <HashLink smooth to="/products-cleansing">
          {t("Cleaner & Disinfectant")}
        </HashLink>
      </Box>
      {/* <Box className="menu_small_title" sx={{ pl: 2 }}>
        <HashLink smooth to="/products-cleansing#pet">
          {t("Pet Care")}
        </HashLink>
      </Box> */}
    </Grid>
  );
};

export default CleansingMenu;
